import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import "./home.css";
import { useDispatch, useSelector } from "react-redux";

import {
  doc,
  onSnapshot,
  db,
  collection,
  query,
  where,
  auth,
  signOut,
} from "../../utils/firebase-config";
import { setCurrentUser, setTables } from "../../redux/actions";
import HomeTop from "./components/top";
import HomeTables from "./components/tables";
import { AppColors } from "../../utils/global-constants";

const HomeScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.currentUser);
  const tables = useSelector((state) => state.tables);
  const userId = localStorage.getItem("user_id");

  const _logoutHandler = () => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_email");
    dispatch(setCurrentUser(null));
    signOut(auth);
    navigate("/");
  };

  useEffect(() => {
    if (!userId) {
      navigate("/");
      return;
    }
    const userInfoListener = onSnapshot(
      doc(db, "hardPackUsers", userId),
      (doc) => {
        if (doc.exists()) {
          dispatch(setCurrentUser(doc.data()));
        }
      }
    );

    const q = query(
      collection(db, "hardPackTables"),
      where("status", "!=", "closed")
    );
    const tablesListener = onSnapshot(q, (snapshot) => {
      console.log(snapshot, "snapshot");
      const newRows = snapshot?.docs.map((doc_) => doc_.data());
      dispatch(setTables(newRows));
    });
    return () => {
      userInfoListener();
      tablesListener();
    };
  }, [userId, navigate, dispatch]);

  return (
    <div className="home-container">
      <div className="home-container-content">
        <div className="home-container-content-wrapper">
          {currentUser && (
            <HomeTop currentUser={currentUser} logout={_logoutHandler} />
          )}
        </div>
        {tables.length > 0 && (
          <div className="home-container-content-wrapper-tables">
            <div className="home-container-content-wrapper-tables-header">
              <p style={{ color: AppColors.main }}>Tables</p>
              <HomeTables tables={tables} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeScreen;
